/**
 * Session 31 · Google Consent Mode v2.
 *
 * Muss **vor** dem eigentlichen gtag/js-Load initialisiert werden
 * (`default`-Signale), damit Google-Skripte die Nutzer-Zustimmung
 * sofort kennen. Bei jeder Consent-Änderung wird `update` gefeuert.
 *
 * Signale:
 *   - ad_storage           · Marketing-Consent
 *   - ad_user_data         · Marketing-Consent
 *   - ad_personalization   · Marketing-Consent
 *   - analytics_storage    · Analytics-Consent
 */

function pushCmd(cmd, ...args) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(function () {
    // arguments-Push ist Google-Standard für dataLayer
    // eslint-disable-next-line prefer-rest-params
    window.gtag && window.gtag(cmd, ...args);
  });
  // Fallback für Zeitpunkt vor gtag-Load
  window.dataLayer.push([cmd, ...args]);
}

let _installed = false;

export function installConsentModeDefaults() {
  if (_installed) return;
  _installed = true;
  window.dataLayer = window.dataLayer || [];
  // Google verlangt VOR dem ersten gtag-Call ein `default`-Signal.
  window.dataLayer.push([
    "consent",
    "default",
    {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      wait_for_update: 500,
    },
  ]);
}

export function updateConsentMode({ analytics = false, marketing = false } = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push([
    "consent",
    "update",
    {
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
      analytics_storage: analytics ? "granted" : "denied",
    },
  ]);
  // Wenn gtag bereits geladen ist, ebenfalls direkt feuern
  if (typeof window.gtag === "function") {
    try { pushCmd("consent", "update", {
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
      analytics_storage: analytics ? "granted" : "denied",
    }); } catch (_) { /* noop */ }
  }
}
